import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { withTheme } from 'styled-components'

import { FlightType } from '../../../../flightStatus/src/flightDetailsMapper.js'

import HeaderView from './HeaderView.jsx'
import HeaderViewMobile from './HeaderViewMobile.jsx'

const noop = () => { }

export const FlightSearchHeader = withTheme(({
  widgetState,
  onSearchTermChange = noop,
  onFlightTypeSwitched = noop,
  clientName,
  logoLinkUrl,
  logoUrl,
  onBackButtonClicked,
  isDesktop,
  T
}) => {
  const [state, setState] = useState(widgetState.getState())
  useEffect(() => widgetState.addCallback(setState), [widgetState])

  const { currentFlightType, searchTerm } = state
  const placeholder = currentFlightType === FlightType.DEPARTURE ? T('flightDetails:Search Departures') : T('flightDetails:Search Arrivals')

  return isDesktop
    ? <HeaderView
      currentFlightType={currentFlightType}
      placeholder={placeholder}
      searchTerm={searchTerm}
      onFlightTypeSwitched={onFlightTypeSwitched}
      onSearchTermChange={onSearchTermChange}
      onBackButtonClicked={onBackButtonClicked}
      logoUrl={logoUrl}
      logoLinkUrl={logoLinkUrl}
      clientName={clientName}
      T={T}
    />
    : <HeaderViewMobile
      currentFlightType={currentFlightType}
      placeholder={placeholder}
      searchTerm={searchTerm}
      onFlightTypeSwitched={onFlightTypeSwitched}
      onSearchTermChange={onSearchTermChange}
      onBackButtonClicked={onBackButtonClicked}
      T={T}
    />
})

FlightSearchHeader.propTypes = {
  widgetState: PropTypes.object.isRequired,
  onSearchTermChange: PropTypes.func,
  onFlightTypeSwitched: PropTypes.func
}
